import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo } from "react";
import {
  closeSignInModal,
  openSignInModal,
  setIntendedRoute,
} from "../../store";
import AuthenticationSkeleton from "../skeletons/pagesSpecific/Login/AuthenticationSkeleton";
import { setPendingInvitation } from "../../store/slices/authSlice";

export const ProtectedClientRoute = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { isAuthenticated, isSignInModalOpen, user } = useSelector(
    (state) => state.auth
  );
  
  // Extract invitation token from URL - use useMemo or useCallback
  const invitationToken = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("invitation");
  }, [location.search]);

  useEffect(() => {
    if (invitationToken) {
      dispatch(setPendingInvitation({
        token: invitationToken,
        source: 'url',
        timestamp: Date.now(),
        redirectUrl: location.pathname + location.search
      }));
    }
  }, [invitationToken, dispatch, location]);

  useEffect(() => {
    // Not authenticated → open login modal
    if (!isAuthenticated && !isSignInModalOpen) {
      const fullUrl = location.pathname + location.search;
      dispatch(setIntendedRoute(fullUrl));
      dispatch(openSignInModal());
    }
  }, [isAuthenticated, isSignInModalOpen, location, dispatch]);

  // Not authenticated
  if (!isAuthenticated) {
    return <AuthenticationSkeleton />;
  }

  // Authenticated but pending approval
  if (user?.status === "pending") {
    return <Navigate to="/pending-approval" replace />;
  }

  // ----- Existing subscription logic -----
  if (isAuthenticated) {
    if (location.pathname === "/" || location.pathname === "/services") {
      if (user?.hasActiveSubscription) {
        return <Navigate to="/my-subscriptions" replace />;
      }
    }
  }

  if (location.pathname === "/my-subscriptions") {
    if (!user?.hasActiveSubscription) {
      return <Navigate to="/services" replace />;
    }
  }

  // Fully authorized
  return <Outlet />;
};

export const PublicRoute = () => {
  return <Outlet />;
};